export default {"src":"/_next/static/media/FROG.bf61ce63.svg","height":18,"width":18};